import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AVGWritePermissie } from '../../dto/avg-dashboard-model-classes';

@Component({
    selector: 'app-koppeling-aanmaken-stap2',
    templateUrl: './koppeling-aanmaken-stap2.component.html',
    styleUrls: ['./koppeling-aanmaken-stap2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KoppelingAanmakenStap2Component implements OnInit, OnDestroy {

    public toonUitleg = false;
    public toonResetTooltip = false;

    public bevatOptioneleVelden: boolean = true;

    @Input()
    public viewModel: KoppelingAanmakenStap2ComponentViewModel;

    private subscriptions: Subscription[] = [];

    constructor() { }

    ngOnInit(): void {
        this.subscriptions.push(this.viewModel.onGetVelden.pipe(map(e => {
            let heeftOptioneleVelden = false;
            e.forEach(ep => ep.categorieen.forEach(c => c.velden.forEach(v => {
                if (!v.verplicht) heeftOptioneleVelden = true;
            })));
            return heeftOptioneleVelden;
        })).subscribe(heeftOptioneleVelden => this.bevatOptioneleVelden = heeftOptioneleVelden));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    public endpointClass(endpoint: Endpoint, index: number): string {
        let cl: string = index % 2 !== 0 ? 'endpoint' : 'endpoint uneven';
        // Ruimte maken voor tooltip omdat die anders achter de button bar valt
        if (endpoint.categorieen.find(c => c.velden[c.velden.length - 1].properties?.find(prop => prop.type === 'warning'))) cl += ' roomForTooltip';
        return cl;
    }

    public veldIconClass(veld: Veld): string {
        return veld.verplicht ? 'icon dot' : veld.selected ? 'icon checked' : 'icon unchecked';
    }

    public veldSchrijvenIconClass(veld: Veld): string {
        return veld.properties.find(p => p.type==='Schrijven') ? 'icon checked' : 'icon unchecked';
    }

    public veldClass(veld: Veld): string {
        return veld.verplicht ? 'veld' : 'veld clickable';
    }

    public onVeldClicked(veld: Veld): void {
        veld.selected = !veld.selected;
        if(!veld.selected){
            veld.properties = veld.properties.filter(p => p.type!='Schrijven')
        }
    }

    public onVrijVeldSchrijvenClicked(veld: Veld): void {
        let huidig = veld.properties.find(p => p.type==='Schrijven')
        if(huidig){
            veld.properties = veld.properties.filter(p => p.type!='Schrijven')
        }
        else{
            veld.properties = [...veld.properties, {type: 'Schrijven', description: ''}]
            veld.selected = true;
        }
    }

    public showUitleg(): void {
        this.toonUitleg = true;
    }

    public closeUitleg(): void {
        this.toonUitleg = false;
    }

    public showResetTooltip(): void {
        this.toonResetTooltip = true;
    }

    public hideResetTooltip(): void {
        this.toonResetTooltip = false;
    }

    public isVrijVeld(categorie: Categorie, endpoint: Endpoint){
        let magschrijven = false;
        this.viewModel.onGetWritePermissies.pipe(map(p => {
            let schrijfrecht = false;
            schrijfrecht = p.find(permissie => permissie.endpoint === endpoint.naam) != undefined;
            return schrijfrecht;
        })).subscribe(schrijfrechten => magschrijven = schrijfrechten)
        return magschrijven && categorie.naam === 'Vrije velden';
    }

    public propertyClass(prop: VeldProperty): string {
        switch (prop.type) {
            case 'warning':
                return 'remark warning';
            case 'write':
                return 'remark write';
            case 'none':
                return '';
            default:
                return 'remark';
        }
    }
}

export interface KoppelingAanmakenStap2ComponentViewModel {
    onGetKoppelpartijNaam: Observable<string>;
    onGetVelden: Observable<Endpoint[]>;
    doResetVelden: Subject<void>;
    onGetWritePermissies:  Observable<AVGWritePermissie[]>;
}

export interface Endpoint {
    naam: string;
    writePermissies: boolean;
    categorieen: Categorie[];
}

export interface Categorie {
    naam: string;
    velden: Veld[];
}

export interface Veld {
    verplicht: boolean;
    selected: boolean;
    naam: string;
    entityIndex: number;
    fieldIndex: number;
    properties: VeldProperty[];
    subFields: any;
}

export interface VeldProperty {
    description: string;
    type: string;
}
